/* ZImageFunct
Versione 1.0.0 - 07 Ottobre 2022 - Tommaso Martinoli
                 - Prima versione
*/

export class TZImageFunct
{

  static ResizeImage(Img,MaxWidth,MaxHeight,type) 
  {
    var Ratio       = 1;
    var FinalWidth  = 0;
    var FinalHeight = 0;

    //IL PARAMETRO TYPE SI RECUPERA IN QUESTO MODO : 
    //var ImgFile = document.getElementById("ID_IMMAGINE"); 
    //var TypeImg = ImgFile.files[0].type;

    if (Img.height != 0 && Img.width != 0) 
    {
       Ratio = Img.height / Img.width;
       if(Img.width > Img.height) 
       {
          FinalWidth  = MaxWidth;
          FinalHeight = Math.trunc(MaxWidth * Ratio);
          if(FinalHeight > MaxHeight)
          {
              FinalHeight = MaxHeight;
              FinalWidth  = Math.trunc(FinalHeight / Ratio);
          }
          else 
          {
              FinalHeight = FinalHeight;
              FinalWidth  = Math.trunc(FinalHeight / Ratio);
          }
       }
       else
       {
          FinalHeight = MaxHeight;
          FinalWidth  = Math.trunc(MaxHeight / Ratio);
          if(FinalWidth > MaxWidth)
          {
              FinalWidth  = MaxWidth;
              FinalHeight = Math.trunc(FinalWidth * Ratio);
          }
          else 
          {
              FinalWidth = FinalWidth;
              FinalHeight = Math.trunc(FinalWidth * Ratio);
          }
       }
    }
    else
    {
      FinalWidth  = MaxWidth;
      FinalHeight = MaxHeight;
    }

    var canvas = document.createElement("canvas");
    var ctx    = canvas.getContext("2d");
    //ctx.drawImage(Img, 0, 0, FinalWidth, FinalHeight);
    
    canvas.width = FinalWidth;   
    canvas.height = FinalHeight;
    
    ctx.drawImage(Img,0,0,Img.width,Img.height,0,0, canvas.width, canvas.height);
    
    var dataurl = canvas.toDataURL(type);
    Img.src     = dataurl;

    return Img;
  }
  
}
